module.exports = __webpack_public_path__ + "img/qy2@2x.4f74fbe3.png";